import React from "react"
import classnames from "classnames"
import styles from "./styles/index.css"

export default BaseComponent => ({
  className,
  bt,
  br,
  bb,
  bl,
  bx,
  ...restProps
}) => {
  const newClassName = classnames(className, {
    [styles.bt]: bt,
    [styles.br]: br,
    [styles.bb]: bb,
    [styles.bl]: bl,
    [styles.bx]: bx,
  })
  return <BaseComponent className={newClassName} {...restProps} />
}
